<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Through the Canyons and Two National Parks</h1>
    <div class='tourPic'>
      <img src='@/assets/daytours/tour1/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              This is probably the most popular day tour to the north of the country, which in its different variations, includes impressive landscapes, spectacular canyons, ancient and thick forests, fast mountain streams, the most famous Montenegrin glacial lakes, rich cultural historical heritage and untouched nature. The tour largely evades crowds and will leave you with the feeling that it lasted much longer than it really did. Photographs made on this tour will enchant you over and over again.
            </p>
            <p class='pasus'>
              The program of this tour comprises two spectacular canyons – Moraca river canyon with its dramatic vertical cliffs, clear water flowing in different shades of green, 1000 meters deep and Tara canyon, 1300 m deep (one of the deepest canyons in the world), run through by the river called “the tear of Europe” whose slopes are connected by one of the most stunning bridges in the world – Djurdjevica Tara bridge.
            </p>
            <p class='pasus'>
              Specific gems of this tour are two miraculous national parks – Biogradska Gora and Durmitor with their untouched nature, ancient forests, abundant flora and fauna, glacial lakes, amazing landscapes… One of the three remaining green forests in Europe, strictly protected, is situated in Biogradska Gora national park while the black pine forest Crna Poda in Durmitor national park is a home to some of the oldest and the highest trees in the world.
            </p>
            <p class='pasus'>
              This tour offers a variety of other attractions that will equally impress you while tasting local specialties will certainly be recommended.
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour – Private</p>
            <p class='pasus'>Availability - May – October</p>
            <p class='pasus'>Group size – 1-7</p>
            <p class='pasus'>Depature – From Podgorica</p>
            <p class='pasus'>Difficulty – easy</p>
            <p class='pasus'>Duration – 12-13 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
               <li class='pasus'> 8.30 a.m. - a pick up at your place of stay or at the place we agree upon. </li>
              <li class='pasus'> After approximately 40 minutes of comfortable drive we arrive at the viewpoint in the deepest part of the Moraca river canyon. We enjoy looking at the dramatic canyon cliffs and clear water.   </li>
              <li class='pasus'> We continue up the main road to reach Biogradska Gora national park in 60 minutes.  </li>
              <li class='pasus'> We spend between 30 minutes and 2 hours at the national park, depending on whether we agree to take a walk around the lake.  </li>
              <li class='pasus'> We continue further driving by the Tara River and through the very canyon until reaching our next stop to breathe deeply surrounded by the black pine trees, centuries old.  </li>
              <li class='pasus'> The road down the Tara canyon lead us to the spectacular bridge where we can take a coffee break, do the zip line, or take lunch… </li>
              <li class='pasus'>  About half-hour drive from the bridge sits Durmitor national park, with the shiniest of its 18 glacial lakes that are in the park – Black Lake. </li>
              <li class='pasus'>  After easy walk and enjoying the stunning landscapes, we slowly head back to Podgorica. The comeback is expected at 8.30 p.m.  </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 4.5 hours</p>
              <p> <i class='fas fa-route'></i> 280 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 210 eur</li>
              <li class='pasus'>2 persons – 120 eur p/person</li>
              <li class='pasus'>3 persons – 90 eur p/person</li>
              <li class='pasus'>4 persons – 75 eur p/person</li>
              <li class='pasus'>5 persons- 90 eur p/person</li>
              <li class='pasus'>6 persons – 80 eur p/person</li>
              <li class='pasus'>7 persons – 75 eur p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Travel insurance</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>National park tickets</li>
              <li class='pasus'>Professional guiding service- English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a jacket, a cap, sunglasses, some sweets and footwear adequate to conditions in the mountain area.
              </li>
              <li class='pasus'>
                The difference in altitude is 1.400 meters. We start at the elevation of 50 meters to reach the highest point at 1450 meters.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Visit to Monastery Moraca</li>
              <li class='pasus'>Walks during the tour</li>
              <li class='pasus'>
                Itinerary changes as agreed (do not affect the price)
              </li>
              <li class='pasus'>Lunch at mountain restaurant</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/daytours/tour1/01.jpg'),
          thumbnail: require('@/assets/daytours/tour1/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour1/02.jpg'),
          thumbnail: require('@/assets/daytours/tour1/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour1/03.jpg'),
          thumbnail: require('@/assets/daytours/tour1/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour1/04.jpg'),
          thumbnail: require('@/assets/daytours/tour1/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour1/05.jpg'),
          thumbnail: require('@/assets/daytours/tour1/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour1/06.jpg'),
          thumbnail: require('@/assets/daytours/tour1/06.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DT1_ThroughCanyons.vue